import dataStore from '../../data/data';

const Check = async () => {
  const data = dataStore.getState();
  let checks = [];

  const getID = (id) => {
    if (!id || id.trim() === '') {
      checks.push({ step: 'ID check', ok: false, reason: 'ID is missing' });
      return null;
    }

    checks.push({ step: 'ID check', ok: true });
    return id;
  };

  const checkS3 = async (id) => {
    const date = data.mirror?.currentDate;
    const url = `${process.env.REACT_APP_PHI_WEB_URL}/mirror-cast-check?uuid=${id}&date=${date}&env=${process.env.REACT_APP_STAGING}`;
    
    try {
      const resp = await fetch(url);
      const json = await resp.json();
  
      if (!json.exists) {
        checks.push({
          step: 'data_server.json exists',
          ok: false,
          reason: 'File not found in S3',
        });
      } else {
        checks.push({
          step: 'data_server.json exists',
          ok: true,
        });
      }

    } catch (err) {
      console.log('Check fetch error:', err);
      checks.push({
        step: 'data_server.json exists',
        ok: false,
        reason: 'Fetch error',
      });
    }
  };

  const vitruvianId = getID(data.mirror.vitruvianId);
  if (vitruvianId)
    await checkS3(vitruvianId);

  return checks;
};

export default Check;